// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__BPrF1","label":"styles_label__22FmB","input":"styles_input__36mAq","error":"styles_error__v7---"};